import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=1c6f6baf&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=1c6f6baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f6baf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6f6baf')) {
      api.createRecord('1c6f6baf', component.options)
    } else {
      api.reload('1c6f6baf', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=1c6f6baf&scoped=true&", function () {
      api.rerender('1c6f6baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-268mzVIqTumMG/JS/comp/GuestBox.vue"
export default component.exports